export const InspectionForm = () => <div className='title'>
  <h1>hello, hello...</h1>
</div>;